import { Modal } from "flowbite-react";
import { createRenter } from "@/common/services/renters.api";
import { useToastContext } from "@/common/components/ui/toast/toast.context";
import FormCreateRenter from "@/modules/renters/components/forms/FormCreateRenter";

type Props = {
  onClose?: () => void;
  onSave: (renterId: string) => void;
  idCompanyB2B: string;
};

export default function ModalCreateRenterB2B(props: Props) {
  const { notifySuccess, notifyError } = useToastContext();

  const handleCloseModal = () => {
    props.onClose && props.onClose();
  };

  async function handleSubmit(dataToSave: {
    name: string;
    cpf: string;
    groupName: string;
  }) {
    try {
      const dataB2B = {
        ...dataToSave,
        isB2Bcontrat: true,
        idCompanyB2B: props.idCompanyB2B,
      };

      const result = await createRenter(dataB2B);

      const { ok, data } = result;
      if (ok && data) {
        props.onSave((data as { _id: string })?._id);
        notifySuccess(
          `Cliente B2B "${(data as { name: string }).name}" cadastrado!`
        );
      }
      if (!result.ok) {
        notifyError(result.message as string);
      }
    } catch (err) {
      console.log(err);
      notifyError((err as Error).message as string);
    }
  }

  return (
    <Modal
      className="relative text-black"
      show={true}
      onClose={() => handleCloseModal()}
    >
      <Modal.Header className="text-black">
        <h2 className="text-black">Novo Cliente B2B</h2>
      </Modal.Header>
      <Modal.Body>
        <FormCreateRenter onSubmit={handleSubmit} />
      </Modal.Body>
    </Modal>
  );
}
